import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=b8a6bb68&scoped=true&"
import script from "./searchForm.vue?vue&type=script&lang=js&"
export * from "./searchForm.vue?vue&type=script&lang=js&"
import style0 from "./searchForm.vue?vue&type=style&index=0&id=b8a6bb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a6bb68",
  null
  
)

export default component.exports